import React, { useCallback, useEffect, useState } from 'react';
import { prop } from 'ramda';
import { useNavigate } from '@theme/js/hooks/navigate';
import { useAppSelector, useDeviceSelector, usePageSelector } from '@core/js/store/hooks';
import { LocalPopup } from '@theme/js/components/common/Popup';

import { Layout } from '@core/js/components/system/Page/components/Layout';
import { getRootClassNames } from '@theme/js/components/system/Page/helpers';

import style from './PagePopup.scss';

/* Lugano changes */
export const useNavigateToPopup = ({ gameInfoPopup }) => {
    const navigate = useNavigate();
    const rootPage = useAppSelector(prop('rootPage'));
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));
    const backgroundPagePathIsRoot = popupBackgroundPagePath === rootPage;
    const gamePopupInRootPage = gameInfoPopup || backgroundPagePathIsRoot ? '/' : popupBackgroundPagePath;

    return useCallback(() => {
        navigate(gamePopupInRootPage || rootPage);
    }, [navigate, gamePopupInRootPage, rootPage]);
};
/* Lugano changes */

export const PagePopup = ({ page }) => {
    const { isShowAsModal = false } = page;
    const { popupWidth, popupWidthUnit, hidePopUpTitle, title, rootClassNames } = page;

    /* Lugano changes */
    const [isClosing, setIsClosing] = useState(false);
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const isGameInfoPopup = !isDesktop && rootClassNames === 'game-info';
    const navigateToPopupBackgroundPage = isGameInfoPopup
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ? useNavigateToPopup({ gameInfoPopup: true })
        // eslint-disable-next-line react-hooks/rules-of-hooks
        : useNavigateToPopup({ gameInfoPopup: false });

    const handleClose = () => {
        setIsClosing(true);
    };

    useEffect(() => {
        if (isClosing) {
            const timeoutId = setTimeout(() => {
                navigateToPopupBackgroundPage();
            }, 300);

            return () => clearTimeout(timeoutId);
        }
    }, [isClosing, navigateToPopupBackgroundPage]);

    const containerClassName = `${isGameInfoPopup && isClosing ? style.hidePopupGameInfo : ''} ${isGameInfoPopup && !isClosing ? style.showPopupGameInfo : ''}`;
    const overlayClassName = `${isGameInfoPopup && isClosing ? style.hideGameInfoOverlay : ''} ${isGameInfoPopup && !isClosing ? style.showGameInfoOverlay : ''}`;
    /* Lugano changes */

    return (
        <LocalPopup
            isModal={isShowAsModal}
            onClose={isGameInfoPopup ? handleClose : navigateToPopupBackgroundPage} /* Lugano changes */
            title={hidePopUpTitle ? undefined : title}
            isGameInfoPopup={isGameInfoPopup} /* Lugano changes */
            style={{ width: `${popupWidth}${popupWidthUnit}` }}
            classNames={{
                overlay: overlayClassName, /* Lugano changes */
                gamesInfoPopupLayout: style.gamesInfoPopupLayout, /* Lugano changes */
                gamesInfoPopupLayer: style.gamesInfoPopupLayer }} /* Lugano changes */
            className={`${style.container} ${getRootClassNames(rootClassNames).join(' ')} ${containerClassName}`} /* Lugano changes */
        >
            <Layout page={page} isGameInfoPopup={isGameInfoPopup} isPageInPopup />
        </LocalPopup>
    );
};
